export default "__VITE_ASSET__12986378__"